import * as bootstrap from 'bootstrap'
import lazysizes from 'lazysizes'
import iziToast from 'izitoast'
import axios from 'axios'


// try {
//     window.lazysizes = require('lazysizes')
//     // window.$ = window.jQuery = require('jquery');
//     window.bootstrap = require('bootstrap');
//     // window.Popper = require('@popperjs/core')
//     window.axios = require('axios')
//     window.iziToast = require('izitoast')
//     require('bootstrap');
// } catch (e) {
// }

try {
    window.axios = axios
    window.lazysizes = lazysizes
    window.iziToast = iziToast
    window.bootstrap = bootstrap
} catch (e) {}

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

window.axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const statusCode = error.response ? error.response.status : null
    if (statusCode === 419) {
      window.location = '/login'
    }
    throw error
  },
)
